import Toast from '@/core/components/Toast/Toast';

export default Toast;
